function validateInput(event) {
  // Toetscode van de huidige toetsaanslag
  const key = event.key;

  // Patroon voor het matchen van een decimaal getal met cijfers, een punt of komma
  const regex = /^[0-9.,]+$/;

  // Toestaan van backspace (toetscode: "Backspace") en andere speciale toetsen
  if (key === "Backspace" || key === "Tab" || key === "ArrowLeft" || key === "ArrowRight" || key === "Delete" || key === "Home" || key === "End" || key === "Control" || key === "Alt" || key === "Shift") {
    return;
  }

  // Als de toetsaanslag geen geldig karakter is, onderdruk het standaardgedrag
  if (!regex.test(key)) {
    event.preventDefault();
  }
}

$(document).on('keydown', 'input.quantity_kilo', function(e) {
  validateInput(e);
});

$(document).on('keyup', 'input.quantity_kilo', function() {
    var input = $(this).val();
    input = input.replace(/,/g, '.');
    var grams = input * 1000; // Convert kilograms to grams

    if($(this).hasClass('quantity_kilo--cart')){
        $(this).closest('td.product-quantity').find('input.qty').val(grams);
    }else if($(this).hasClass('quantity_kilo--row')){
        if($(this).next().hasClass('quantity_kilo_row')){
            $(this).next().val(grams);
        }
    }
});

$(document).on('keyup', 'input.quantity_stuk', function() {
    var input = $(this).val();

    if($(this).hasClass('quantity_stuk--cart')){
        $(this).closest('td.product-quantity').find('input.qty').val(input);
    }else if($(this).hasClass('quantity_stuk--row')){
        if($(this).prev().hasClass('quantity_stuk_row')){
            $(this).prev().val(input);
        }
    }
});
